import { createContext, useContext } from 'react';
import { hasWindow } from '@quicktools/shared-components/utils/window';
import Color from 'color';

import { ColorCombinationEnum } from '../types';

import { IStateModel, ActionTypesEnum, IActionModel, ExportStatusEnum } from './types';

const searchParams = new URLSearchParams(hasWindow ? window.location.search : undefined);
const colorsFromUrl =
  searchParams
    .get('colors')
    ?.split(' ')
    .map((item) => new Color(`#${item}`)) || [];
const [mainColorFromUrl, firstColorFromUrl, secondColorFromUrl, thirdColorFromUrl] = colorsFromUrl;
const mainHsva = { h: 300, s: 80, v: 68, a: 1 };
const mainColor = Color.hsv([mainHsva?.h, mainHsva?.s, mainHsva?.v]);

export const initialState: IStateModel = {
  exportStatus: ExportStatusEnum.READY_TO_START,
  mainColorCombination: {
    mainColor: {
      color: mainColorFromUrl || mainColor,
      brightness: 50,
    },
    firstColor: {
      color: firstColorFromUrl || mainColor.rotate(180),
      brightness: 50,
    },
    secondColor: {
      color: secondColorFromUrl || mainColor,
      brightness: 50,
    },
    thirdColor: {
      color: thirdColorFromUrl || mainColor,
      brightness: 50,
    },
  },
  colorCombination:
    (searchParams.get('combination') as ColorCombinationEnum) || ColorCombinationEnum.COMPLEMENTARY,
  hsvaAlphaMain: { h: 180, s: 100, v: 68, a: 0.5 },
  appState: [],
  appStateVersion: -1,
};

export const reducer = (state: IStateModel, { type, payload }: IActionModel): IStateModel => {
  switch (type) {
    case ActionTypesEnum.SET_EXPORT_STATUS:
      return {
        ...state,
        exportStatus: payload,
      };
    case ActionTypesEnum.SET_MAIN_COLOR_COMBINATION:
      return {
        ...state,
        mainColorCombination: payload,
      };
    case ActionTypesEnum.SET_COLOR_COMBINATION:
      return {
        ...state,
        colorCombination: payload,
      };
    case ActionTypesEnum.SET_HSVA_ALPHA:
      return {
        ...state,
        hsvaAlphaMain: payload,
      };
    case ActionTypesEnum.ADD_APP_STATE:
      if (state.appStateVersion + 1 === state.appState.length) {
        return {
          ...state,
          appState: [
            ...state.appState,
            {
              mainColorCombination: state.mainColorCombination,
              colorCombination: state.colorCombination,
              hsvaAlphaMain: state.hsvaAlphaMain,
            },
          ],
          appStateVersion: state.appStateVersion + 1,
        };
      } else {
        return {
          ...state,
          appState: [
            ...state.appState.slice(0, state.appStateVersion + 1),
            {
              mainColorCombination: state.mainColorCombination,
              colorCombination: state.colorCombination,
              hsvaAlphaMain: state.hsvaAlphaMain,
            },
          ],
          appStateVersion: state.appStateVersion + 1,
        };
      }
    case ActionTypesEnum.GO_PREV_VERSSION:
      const prevVersion = state.appStateVersion - 1;

      return {
        ...state,
        ...state.appState[prevVersion],
        appStateVersion: prevVersion,
      };
    case ActionTypesEnum.GO_NEXT_VERSSION:
      const nextVersion = state.appStateVersion + 1;

      return {
        ...state,
        ...state.appState[nextVersion],
        appStateVersion: nextVersion,
      };
    default:
      return state;
  }
};

export const Store = createContext({
  state: initialState,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: (args: any) => {},
});

export const useStore = () => useContext(Store);
